<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <div class="form-help">
            <span>{{ getTranslations.visitor_sign_up_2_2steps_left }}</span>
          </div>
          <div class="progressbar-container">
            <ol :class="['progress ', show2stepsOnlyOrNoneInForgot() ? 'twoStepList' : '' ]">
              <li class="is-complete" data-step="1">
              </li>
              <li class="is-active" data-step="2">
              </li>
              <li data-step="3" class="progress__last" v-if="!show2stepsOnlyOrNoneInForgot()">
              </li>
            </ol>
          </div>
          <div class="signup-form">
            <div class="form-help">
              <p>{{ getTranslations.visitor_sign_up_2_info_msg_unique_code_send }}</p>
              <img class="form-help__icon" src="static/images/keypad-icon.svg" alt="">
            </div>
            <form action="">
              <div class="form-group" :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="text" class="form-group__textfield phone_input"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_2_validation_code"
                       @keyup="check" v-model="user.pin"/>
                <span v-show="getMessage(message) && user.pin" class="form-group__feedback">{{ getMessage(message) }}</span>
              </div>
              <div class="form-footer">
                {{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }} <br><a>
                <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank"
                   v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_3_terms_and_conditions')">
                  {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_3_terms_and_conditions') }}</a>
              </a>
              </div>
              <p v-if="displayPrice || !checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_price')">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_price') }}</p>
              <input id="submitBtn" type="submit" :value="getTranslations.visitor_sign_up_2_submit_button_continue"
                     :class="['btn btn--medium btn--main' , ( hasErrors || waitForResponse ? 'deactivated' : '')]" @click.prevent="checkButton">
              <br/>
              <br/>
              <a href="https://www.google.com" v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit')">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit') }}
              </a>
              <br/>
              <br/>

              <p class="top_disclaimer_extra" v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_disclaimer_extra')">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_disclaimer_extra') }}</p>

              <div class="form-group form-group--mobile">
                <span v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_reg_notice')" class="form-group__feedback reg_notice">
                  * {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_reg_notice') }} </span>

                <p class="form-group__feedback reg_notice" v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_by_clicking')">
                  {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_by_clicking') }}
                </p>
                <ul class="alter_flow_list">
                  <li v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_you_will_start')">
                    {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_you_will_start') }}
                  </li>
                  <li v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_renewal_will')">
                    {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_renewal_will') }}
                  </li>
                  <li v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_no_commitment')">
                    {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_no_commitment') }}
                  </li>
                  <li v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_for_support')">
                    {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_for_support') }}
                  </li>
                </ul>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
    <loading v-if="showLoadingModal"
              @close="showLoadingModal = false">
    </loading>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import DigitalParametersMixin from '@/common/mixins/digital/digitalHelper';
import loading from '@/components/home/modals/shared/Loading';

export default {
  name: 'sign-up-2',
  components: { loading },
  mixins: [RegistrationFlowMixin, DigitalParametersMixin],
  data() {
    return {
      user: {
        pin: '',
        msisdn: '',
      },
      ti: null,
      ts: null,
      message: '',
      hasErrors: false,
      blacklistWords: [],
      waitForResponse: false,
    };
  },
  created() {
    this.retrieveParametersFromBrowserStorage();
    const inputMsisdn = sessionStorage.getItem('msisdn') || this.$route.query.userMsisdn || this.$route.query.msisdn;
    if (inputMsisdn) this.setRegistrationInfo(inputMsisdn);
    if (!this.registrationInfoMsisdn) this.$router.push('/'); // user somehow navigated here (without MSISDN) or refresh SignUp2 page, so next page is getStarted
    const operator = this.$route.query.operator;
    if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.OOREDOO_ALGERIA.name) {
      this.ti = this.generateValue();
      this.ts = this.secondsEpoch();
      /* eslint-disable */
      const params = { ti: this.ti, ts: this.ts, te: encodeURIComponent('#submitBtn'), type: 'pin' };
      const url = `/api/getScript`;
      if (sessionStorage.getItem('isRun')) {
        this.$axios({url, params}).then((response) => {
          let data = response.data;
          console.log(data);
          data.s = data.s.replace('%23submitBtn', '#submitBtn');
          console.log(data.s);
          let scriptToAdd = document.createElement('script');
          scriptToAdd.type = 'text/javascript';
          scriptToAdd.id = 'korek_response';
          // Create contents of the script
          let inlineScript = document.createTextNode("if(sessionStorage.getItem('isRun') === 'true') {\n");
          scriptToAdd.appendChild(inlineScript);
          inlineScript = document.createTextNode(data.s);
          scriptToAdd.appendChild(inlineScript);
          inlineScript = document.createTextNode("\n}");
          scriptToAdd.appendChild(inlineScript);
          document.head.appendChild(scriptToAdd);
          let tag = document.createElement("script");
          tag.type = 'text/javascript';
          tag.id = 'db_response';
          inlineScript = document.createTextNode("if(sessionStorage.getItem('isRun') === 'true') {\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("var event = new Event('DCBProtectRun');\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("document.dispatchEvent(event); \n}");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("sessionStorage.setItem('isRun', 'false');");
          tag.appendChild(inlineScript);
          document.head.appendChild(tag);
          console.log('1');
        });
      }
      console.log('2');
      if (document.getElementById('korek_response')) {
        document.getElementById('korek_response').remove();
        document.getElementById('db_response').remove();
        sessionStorage.setItem('isRun', 'true');
      }
    }
    if (operator) {
      this.storeOperator(operator);
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((response) => {
        this.updateMultiOperatorOrdinal({ value: response.data.data.multiOperatorOrdinal });
        this.setDisplayPrice({ value: response.data.data.displayPrice });
      });
    }
    // OP014586-4 (Phase 2 / Evina) — load the DV Pass DCBProtect companion only for Vodafone-Oman.
    if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.VODAFONE_OMAN.name) {
      this.initializeDVPassScript();
    }
  },
  methods: {
    ...mapActions('common', [
      'storeOperator',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setDisplayPrice',
      'setDVPassChallenge', // OP014586-4
    ]),
    // OP014586-4 (Phase 2 / Evina) — DV Pass DCBProtect companion (Vodafone-Oman only). Kept fully
    // separate from Duel's Ooredoo/Korek antifraud in created(): different SDK (window.dvpass), script
    // host (merchants.dvpass.io), DOM target and event (dvpass-loaded), so there is no shared path.
    async initializeDVPassScript() {
      try {
        const jwt = this.getDVPassJWT;
        await this.loadDVPassScript(jwt);
      } catch (error) {
        // OP014586-4 — hardcoded fallback challenge, kept deliberately (decision 2026-07-23) to mirror
        // Brainiac's proven behavior so a DVPass load failure doesn't block the user from proceeding.
        this.setDVPassChallenge('6dddff6f-ced6-45b6-9b6b-70d9bb77e8e2');
        // eslint-disable-next-line no-console
        console.error('DVPass initialization failed:', error);
        this.waitForResponse = false; // allow the user to proceed even if DVPass fails
      }
    },
    loadDVPassScript(jwt) {
      // Duel's submit button id is #submitBtn (Brainiac used #submitButton) — target Duel's element.
      const targetElement = encodeURIComponent('#submitBtn');
      return new Promise((resolve, reject) => {
        try {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = `https://merchants.dvpass.io/companion/${jwt}?te=${targetElement}&include=dcbProtect`;
          script.onload = () => {
            this.initializeDVPassSDK();
            resolve();
          };
          script.onerror = (error) => {
            // eslint-disable-next-line no-console
            console.error('Failed to load DVPass script:', error);
            this.waitForResponse = false; // allow the user to proceed even if the script fails
            reject(error);
          };
          document.head.appendChild(script);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error creating DVPass script:', error);
          this.waitForResponse = false;
          reject(error);
        }
      });
    },
    initializeDVPassSDK() {
      // Small delay to ensure the injected script is fully executed before we touch window.dvpass.
      setTimeout(() => {
        if (typeof window.dvpass !== 'undefined') {
          try {
            window.dvpass.initialize();
            // dvpass-loaded fires when DVPass is ready to produce a dcbProtect challenge token.
            document.addEventListener('dvpass-loaded', (e) => {
              if (e.detail && e.detail.script === 'dcbProtect') {
                this.waitForResponse = false;
                if (typeof window.dvpass.getDcbProtectChallenge === 'function') {
                  const challenge = window.dvpass.getDcbProtectChallenge();
                  if (challenge) {
                    this.setDVPassChallenge(challenge); // consumed later by verifyPinInApp
                  }
                }
              }
            });
            // Fallback: in case the event already fired before the listener was attached.
            setTimeout(() => {
              if (this.waitForResponse !== false && typeof window.dvpass.getDcbProtectChallenge === 'function') {
                const challenge = window.dvpass.getDcbProtectChallenge();
                if (challenge) {
                  this.setDVPassChallenge(challenge);
                  this.waitForResponse = false;
                }
              }
            }, 1000);
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error initializing DVPass SDK:', error);
            this.waitForResponse = false;
          }
        } else {
          // eslint-disable-next-line no-console
          console.warn('DVPass SDK not available after script load');
          this.waitForResponse = false;
        }
      }, 100);
    },
    generateValue() {
      // eslint-disable-next-line
      return 1001 + '-' + Math.floor(Math.random() * Date.now()) + '-' + Math.floor(Math.random() * Date.now());
    },
    secondsEpoch() {
      return Math.floor(Date.now() / 1000);
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    checkIfTranslationEmptyByOrdinal(ordinal, key) {
      const indexKey = (ordinal ? `${key}.${ordinal}` : key);
      return !this.getTranslations[indexKey];
    },
    sendNewCode() {
      this.$axios.get(`api/requestPin?msisdn=${encodeURIComponent(this.getRegistrationInfo)}&lang=${this.getLocale}`).then((response) => {
        const res = response.data.responseEnum;
        if (res === 'OPERATION_SUCCESS') {
          this.$router.push('register2');
        } else {
          if (res === 'MSISDN_INVALID') {
            this.message = 'visitor_sign_up_invalid_msisdn_msg';
          } else if (res === 'ALREADY_REGISTERED') {
            this.message = 'visitor_sign_up_msisdn_already_registered';
          } else if (res === 'MSISDN_NOT_EXIST') {
            this.message = 'visitor_sign_up_msisdn_not_exists';
          } else if (res === 'MSISDN_BLACKLISTED') {
            this.message = 'visitor_sign_up_msisdn_blacklisted';
          } else if (res === 'BLOCKED_USER') {
            this.message = 'visitor_forgot_password_warning_msd_max_attempts';
          } else if (res === 'SERVER_ERROR') {
            this.message = 'home_profile_profile_edit_server_unvailable';
          } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
            this.message = 'visitor_sign_up_warning_third_party_error';
          }
          this.hasErrors = true;
        }
      });
    },
    check: function check() {
      let validPinRegex = /^[0-9]{0,8}$/;
      if (this.conversionForArabicFields) validPinRegex = /^[٠١٢٣٤٥٦٧٨٩0-9]{0,8}$/;
      const validPin = this.user.pin.match(validPinRegex);
      if (!validPin) {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkButton() {
      if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.OOREDOO_ALGERIA.name) {
        // eslint-disable-next-line
        if (document.getElementById('korek_response')) {
          document.getElementById('korek_response').remove();
          document.getElementById('db_response').remove();
        }
      }
      if (this.user.pin.length >= 4 && this.user.pin.length <= 8 && !this.hasErrors) {
        this.message = '';
        this.waitForResponse = true;
        const alternateVerifyStep = this.getAlternateVerifyPinAction(this.ti, this.ts);
        if (alternateVerifyStep) {
          alternateVerifyStep.call(this);
        } else {
          const activeIntegration = this.getIntegrationConfig.config;
          const hasAsyncCallback = activeIntegration && activeIntegration.asyncCallback;
          const hasAsync = activeIntegration && activeIntegration.asyncPin;
          this.getNextRegistrationStep(hasAsyncCallback, this.hasServerTrack())(hasAsync);
        }
      } else {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'multiOperatorInfo',
      'displayPrice',
      'conversionForArabicFields',
      'availableIntegrations'
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
      'getIntegrationConfig',
      'getDVPassJWT', // OP014586-4
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp2.vue